import { resetAllApis } from "../../api/rtk/resetAllApis";
import { store } from "../../stateManagement/store";
import { navigateTo } from "../../widgets/navigationService/navigationServiceFunctions";
import { clearWebStorage } from "../webStorageSaver";
import { logout } from "./authSlice";

export function logoutApp() {
    clearWebStorage()
    store.dispatch(logout())
    resetAllApis()
    navigateTo('/')
}